import React from 'react';
import { Link } from 'react-router-dom';
import { Check } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { solutions } from '../assets/images';

const SolutionsFlexiblesPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="pt-24">
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h1 className="text-4xl font-bold text-primary-950 mb-6">
                {t('flexibleSolutions.title')}
              </h1>
              <p className="text-lg text-gray-600 mb-8">
                {t('flexibleSolutions.description')}
              </p>
              <div className="space-y-4 mb-8">
                <div className="flex items-center space-x-3">
                  <Check className="text-black flex-shrink-0" size={20} />
                  <span className="text-gray-700">{t('flexibleSolutions.features.terms')}</span>
                </div>
                <div className="flex items-center space-x-3">
                  <Check className="text-black flex-shrink-0" size={20} />
                  <span className="text-gray-700">{t('flexibleSolutions.features.payments')}</span>
                </div>
                <div className="flex items-center space-x-3">
                  <Check className="text-black flex-shrink-0" size={20} />
                  <span className="text-gray-700">{t('flexibleSolutions.features.tailored')}</span>
                </div>
              </div>
              <Link
                to="/contact"
                className="inline-block px-8 py-3.5 bg-black hover:bg-gray-900 text-white font-medium rounded-md transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-2"
              >
                {t('contact.contactUs')}
              </Link>
            </div>
            <div className="relative">
              <img 
                src={solutions}
                alt="Flexible solutions illustration"
                className="w-full h-auto"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SolutionsFlexiblesPage;